<template>
  <div class="aulas-aluno-modal">
    <div v-if="aulas && aulas.length > 0" class="content-section">
      <div class="info-card">
        <h4 class="info-title">Resumo das Aulas</h4>
        <div class="info-grid">
          <div class="info-item">
            <label class="info-label">Total de Aulas</label>
            <span class="info-value">{{ aulas.length }}</span>
          </div>
          <div class="info-item">
            <label class="info-label">Aula Selecionada</label>
            <span class="info-value">#{{ selected }}</span>
          </div>
        </div>
      </div>

      <div class="table-container">
        <Table :headers="['Início', 'Fim', 'Instrutor', 'Status']">
          <tr v-for="(aula, index) in aulas" :key="aula.aulaId">
            <td>{{ utils.formatDate(aula.inicio) }}</td>
            <td>{{ utils.formatDate(aula.fim) }}</td>
            <td>{{ aula.instrutor }}</td>
            <td>
              <div class="status-column">
                <template v-if="!aula.editStatus">
                  <span class="status-text">{{ aula.status || "&lt;Sem status&gt;" }}</span>
                  <button class="edit-btn" @click="startEdit(index)">
                    <Pencil :size="16" />
                  </button>
                </template>
                <template v-else>
                  <input class="status-input" type="text" v-model="aula.status" @keyup.enter="saveStatus(aula, index)"
                    @keyup.esc="cancelEdit(index)">
                  <button class="save-btn" @click="saveStatus(aula, index)">
                    <Check :size="16" />
                  </button>
                  <button class="cancel-btn" @click="cancelEdit(index)">
                    <Close :size="16" />
                  </button>
                </template>
              </div>
            </td>
          </tr>
        </Table>
      </div>
    </div>

    <div v-else class="empty-state">
      <FileDocumentAlertOutline :size="64" color="#9E9E9E" />
      <h4>Nenhuma aula encontrada</h4>
      <p>Não foram encontradas aulas para este aluno.</p>
    </div>

    <div class="modal-actions">
      <Button text="Fechar" color="primary" @handle:click="close">
        <Close :size="18" />
      </Button>
    </div>
  </div>
</template>
<script>
import utils from '@/services/utils.js'

// Componentes Core
import Button from 'core/Button'
import Table from 'core/Table'

// Ícones
import Close from 'icons/Close'
import FileDocumentAlertOutline from 'icons/FileDocumentAlertOutline'
import Check from 'icons/Check'
import Pencil from 'icons/Pencil'

// Componente específico
import AulaAluno from './AulaAluno.vue'

export default {
  name: 'AulasAlunoModal',
  components: {
    Button,
    Table,
    Close,
    FileDocumentAlertOutline,
    Check,
    Pencil,
    AulaAluno
  },
  props: {
    aulas: Array,
    selected: Number,
    schema: String
  },
  data() {
    return {
      utils,
      originalStatus: {}
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },

    startEdit(index) {
      // Salva o status original para poder cancelar
      this.originalStatus[index] = this.aulas[index].status
      // Ativa o modo de edição para esta aula específica
      this.$set(this.aulas[index], 'editStatus', true)
    },

    cancelEdit(index) {
      // Restaura o status original
      this.aulas[index].status = this.originalStatus[index]
      // Desativa o modo de edição
      this.$set(this.aulas[index], 'editStatus', false)
      // Remove o status original salvo
      delete this.originalStatus[index]
    },

    saveStatus(aula, index) {
      console.log(aula)
      this.$http.post(process.env.VUE_APP_URL_API_V2 + '/dashboard/aulas/praticas/atualizarStatusAula', {
        aulaId: aula.aulaId,
        schema: this.schema,
        status: aula.status
      })
        .then(response => {
          if (response.data.success) {
            this.$toasted.show('Status da aula atualizado', {
              icon: 'fa-info',
              position: 'top-right',
              duration: 5000,
              fullWidth: false
            })
            // Desativa o modo de edição
            this.$set(this.aulas[index], 'editStatus', false)
            // Remove o status original salvo
            delete this.originalStatus[index]
          } else {
            this.$toasted.show('Erro ao atualizar status da aula', {
              icon: 'fa-error',
              position: 'top-right',
              duration: 5000,
              fullWidth: false,
              type: 'error'
            })
          }
        })
        .catch(error => {
          console.error('Erro ao atualizar status:', error)
          this.$toasted.show('Erro ao atualizar status da aula', {
            icon: 'fa-error',
            position: 'top-right',
            duration: 5000,
            fullWidth: false,
            type: 'error'
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.aulas-aluno-modal {
  min-width: 70vw;

  @media (max-width: 768px) {
    min-width: auto;
    max-width: 95vw;
  }
}

.modal-title {
  margin: 0 0 1.5rem 0;
  color: #202224;
  font-size: 1.5rem;
  font-weight: 600;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e9ecef;
}

.content-section {
  margin-bottom: 2rem;
}

.info-card {
  background-color: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  padding: 1.5rem;
  margin-bottom: 1.5rem;

  .info-title {
    margin: 0 0 1rem 0;
    color: #374151;
    font-size: 1.125rem;
    font-weight: 600;
  }
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
}

.info-item {
  .info-label {
    display: block;
    font-size: 0.75rem;
    font-weight: 600;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.025em;
    margin-bottom: 0.25rem;
  }

  .info-value {
    font-size: 0.875rem;
    color: #374151;
    font-weight: 500;
  }
}

.table-container {
  overflow-x: auto;
}

.aulas-table {
  width: 100%;
  border-collapse: collapse;

  th {
    background-color: #f8fafc;
    padding: 1rem 0.75rem;
    text-align: left;
    font-weight: 600;
    color: #374151;
    font-size: 0.875rem;
    border-bottom: 1px solid #e5e7eb;

    &:first-child {
      border-top-left-radius: 0.75rem;
      width: 20%;
    }

    &:nth-child(2) {
      width: 20%;
    }

    &:nth-child(3) {
      width: 30%;
    }

    &:last-child {
      border-top-right-radius: 0.75rem;
      width: 30%;
    }
  }
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 3rem 1rem;

  h4 {
    margin: 1rem 0 0.5rem 0;
    color: #202224;
    font-size: 1.25rem;
    font-weight: 600;
  }

  p {
    margin: 0;
    color: #6b7280;
    font-size: 0.875rem;
    max-width: 400px;
    line-height: 1.5;
  }
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 1rem;
  border-top: 1px solid #e9ecef;
}

// Estilo para destacar a aula selecionada
:deep(.aula-selecionada) {
  background-color: #d1fae5 !important;

  td {
    background-color: #d1fae5;
    border-color: #059669;
  }
}

// Estilos para a coluna de status
.status-column {
  display: flex;
  align-items: center;
  gap: 0.5rem;

  .status-text {
    color: #374151;
    font-size: 0.875rem;
    flex: 1;
  }

  .edit-btn,
  .save-btn,
  .cancel-btn {
    background: none;
    border: none;
    padding: 0.25rem;
    cursor: pointer;
    color: #6b7280;
    transition: color 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      color: #374151;
    }

    &:focus {
      outline: none;
      color: #3b82f6;
    }
  }

  .save-btn {
    color: #059669;

    &:hover {
      color: #047857;
    }
  }

  .cancel-btn {
    color: #dc2626;

    &:hover {
      color: #b91c1c;
    }
  }

  .status-input {
    background: none;
    border: none;
    border-bottom: 1px solid #d1d5db;
    padding: 0.25rem 0;
    font-size: 0.875rem;
    color: #374151;
    flex: 1;
    min-width: 100px;

    &:focus {
      outline: none;
      border-bottom-color: #3b82f6;
    }
  }
}

// Responsividade
@media (max-width: 576px) {
  .aulas-table {
    font-size: 0.75rem;

    th,
    td {
      padding: 0.5rem;
    }
  }

  .status-column {
    gap: 0.25rem;

    .status-input {
      min-width: 80px;
      font-size: 0.75rem;
    }
  }
}
</style>
